export interface DeviceRemoteAccess {
    configured: boolean;
    credentialVersion: number;
    clientVersion: string;
    lastSyncedAt: number;
}

export class DeviceInfo {

    private active: boolean;
    private battery: string;
    private brand: string;
    private brightness: string;
    private centerInternalId: string;
    private connectionDevice: string;
    private description: string;
    private deviceImage: string;
    private deviceName: string;
    private deviceTypeImage: string;
    private deviceTypeName: string;
    private internalId: string;
    private ipAddress: string;
    private lastConnection: string;
    private lastScreenshot: string;
    private location: string;
    private locked: boolean;
    private mac: string;
    private major: number;
    private minor: number;
    private model: string;
    private note: string;
    private osVersion: string;
    private paperOut: boolean;
    private platform: string;
    private pushToken: string;
    private properties: string;
    private screenshotDate: number;
    private serialNumber: string;
    private signal: number;
    private status: string;
    private udid: string;
    private volume: string;
    private wifiSsid: string;
    private remoteAccess: DeviceRemoteAccess;

    constructor(active?: boolean, battery?: string, brand?: string, brightness?: string, centerInternalId?: string, connectionDevice?: string, description?: string, deviceImage?: string, deviceName?: string, deviceTypeImage?: string, deviceTypeName?: string, internalId?: string, ipAddress?: string, lastConnection?: string, lastScreenshot?: string, location?: string, locked?: boolean, mac?: string, major?: number, minor?: number, model?: string, note?: string, osVersion?: string, paperOut?: boolean, platform?: string, pushToken?: string, properties?: string, screenshotDate?: number, serialNumber?: string, signal?: number, status?: string, udid?: string, volume?: string, wifiSsid?: string, remoteAccess?: DeviceRemoteAccess) {
        this.active = active;
        this.battery = battery;
        this.brand = brand;
        this.brightness = brightness;
        this.centerInternalId = centerInternalId;
        this.connectionDevice = connectionDevice;
        this.description = description;
        this.deviceImage = deviceImage;
        this.deviceName = deviceName;
        this.deviceTypeImage = deviceTypeImage;
        this.deviceTypeName = deviceTypeName;
        this.internalId = internalId;
        this.ipAddress = ipAddress;
        this.lastConnection = lastConnection;
        this.lastScreenshot = lastScreenshot;
        this.location = location;
        this.locked = locked;
        this.mac = mac;
        this.major = major;
        this.minor = minor;
        this.model = model;
        this.note = note;
        this.osVersion = osVersion;
        this.paperOut = paperOut;
        this.platform = platform;
        this.properties = properties;
        this.pushToken = pushToken;
        this.screenshotDate = screenshotDate;
        this.serialNumber = serialNumber;
        this.signal = signal;
        this.status = status;
        this.udid = udid;
        this.volume = volume;
        this.wifiSsid = wifiSsid;
        this.remoteAccess = remoteAccess;
    }

    public get Active() {
        return this.active;
    }
    public get Battery() {
        return this.battery;
    }
    public get Brand() {
        return this.brand;
    }
    public get Brightness() {
        return this.brightness;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get ConnectionDevice() {
        return this.connectionDevice;
    }
    public get Description() {
        return this.description;
    }
    public get DeviceImage() {
        return this.deviceImage;
    }
    public get DeviceName() {
        return this.deviceName;
    }
    public get DeviceTypeImage() {
        return this.deviceTypeImage;
    }
    public get DeviceTypeName() {
        return this.deviceTypeName;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get IpAddress() {
        return this.ipAddress;
    }
    public get LastConnection() {
        return this.lastConnection;
    }
    public get LastScreenshot() {
        return this.lastScreenshot;
    }
    public get Location() {
        return this.location;
    }
    public get Locked() {
        return this.locked;
    }
    public get Mac() {
        return this.mac;
    }
    public get Major() {
        return this.major;
    }
    public get Minor() {
        return this.minor;
    }
    public get Model() {
        return this.model;
    }
    public get Note() {
        return this.note;
    }
    public get OsVersion() {
        return this.osVersion;
    }
    public get PaperOut() {
        return this.paperOut;
    }
    public get Platform() {
        return this.platform;
    }
    public get Properties() {
        return this.properties;
    }
    public get PushToken() {
        return this.pushToken;
    }
    public get ScreenshotDate() {
        return this.screenshotDate;
    }
    public get SerialNumber() {
        return this.serialNumber;
    }
    public get Signal() {
        return this.signal;
    }
    public get Status() {
        return this.status;
    }
    public get Udid() {
        return this.udid;
    }
    public get Volume() {
        return this.volume;
    }
    public get WifiSsid() {
        return this.wifiSsid;
    }
    public get RemoteAccess(): DeviceRemoteAccess {
        return this.remoteAccess;
    }
    public set Active(active) {
        this.active = active;
    }
    public set Battery(battery) {
        this.battery = battery;
    }
    public set Brand(brand) {
        this.brand = brand;
    }
    public set Brightness(brightness) {
        this.brightness = brightness;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set ConnectionDevice(connectionDevice) {
        this.connectionDevice = connectionDevice;
    }
    public set Description(description) {
        this.description = description;
    }
    public set DeviceImage(deviceImage) {
        this.deviceImage = deviceImage;
    }
    public set DeviceName(deviceName) {
        this.deviceName = deviceName;
    }
    public set DeviceTypeImage(deviceTypeImage) {
        this.deviceTypeImage = deviceTypeImage;
    }
    public set DeviceTypeName(deviceTypeName) {
        this.deviceTypeName = deviceTypeName;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set IpAddress(ipAddress) {
        this.ipAddress = ipAddress;
    }
    public set LastScreenshot(lastScreenshot) {
        this.lastScreenshot = lastScreenshot;
    }
    public set Location(location) {
        this.location = location;
    }
    public set Locked(locked) {
        this.locked = locked;
    }
    public set Mac(mac) {
        this.mac = mac;
    }
    public set Major(major) {
        this.major = major;
    }
    public set Minor(minor) {
        this.minor = minor;
    }
    public set Model(model) {
        this.model = model;
    }
    public set Note(note) {
        this.note = note;
    }
    public set OsVersion(osVersion) {
        this.osVersion = osVersion;
    }
    public set PaperOut(paperOut) {
        this.paperOut = paperOut;
    }
    public set Platform(platform) {
        this.platform = platform;
    }
    public set Properties(properties) {
        this.properties = properties;
    }
    public set PushToken(pushToken) {
        this.pushToken = pushToken;
    }
    public set ScreenshotDate(screenshotDate) {
        this.screenshotDate = screenshotDate;
    }
    public set SerialNumber(serialNumber) {
        this.serialNumber = serialNumber;
    }
    public set Signal(signal) {
        this.signal = signal;
    }
    public set Status(status) {
        this.status = status;
    }
    public set Udid(udid) {
        this.udid = udid;
    }
    public set Volume(volume) {
        this.volume = volume;
    }
    public set WifiSsid(wifiSsid) {
        this.wifiSsid = wifiSsid;
    }
    public set RemoteAccess(remoteAccess: DeviceRemoteAccess) {
        this.remoteAccess = remoteAccess;
    }
}
